<body>
  <ng-template [ngIf]="canAccessApp" [ngIfElse]="errorBlock">
    <app-nav-menu *ngIf="canActivateProtectedRoutes$ | async as boolean"></app-nav-menu>
    <div class="navbar-offset">
      <router-outlet></router-outlet>
    </div>
    <app-auto-logout></app-auto-logout>
  </ng-template>

  <ng-template #errorBlock>
    <div class="horizontal-navbar center" *ngIf="errorMessage">
      <nav class="navbar pr-0 d-flex">
        <div class="navbar-brand d-flex align-items-center">
          <img [src]="brandLogo" class="logo-img" />
          <span class="brand-name">{{ brandName }}</span>
        </div>
      </nav>
      <div class="border-top pt-4 pl-3 d-flex justify-content-start">
        <h4>{{ errorHeader }}</h4>
      </div>
      <p class="border-bottom pt-4 pl-3 d-flex justify-content-start">
        {{ errorMessage }}
      </p>
    </div>
  </ng-template>
</body>